import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class Managers extends CommonCRUD {}

export default Managers;
